"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisiteRoutes = void 0;
var RequisiteRoutes;
(function (RequisiteRoutes) {
    RequisiteRoutes["BasePrefix"] = "requisites";
    RequisiteRoutes["ById"] = ":requisiteId";
    RequisiteRoutes["All"] = "all";
})(RequisiteRoutes = exports.RequisiteRoutes || (exports.RequisiteRoutes = {}));
